exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rating-block{direction:ltr;letter-spacing:0;color:inherit;position:absolute;margin:0 10px;display:block;position:relative}.rating-star img{display:inline-block}", ""]);

// exports
